import { render, staticRenderFns } from "./ManageReservationTypes.vue?vue&type=template&id=10f449ee&scoped=true"
import script from "./ManageReservationTypes.vue?vue&type=script&lang=js"
export * from "./ManageReservationTypes.vue?vue&type=script&lang=js"
import style0 from "./ManageReservationTypes.vue?vue&type=style&index=0&id=10f449ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f449ee",
  null
  
)

export default component.exports